import createUseAdminSettingsQueryOptions from '@/modules/core/functions/createUseAdminSettingsQueryOptions';
import type { AdminSettings } from '@/modules/core/types/AdminSettings';
import usePublicWretch from '@/modules/query-client/hooks/usePublicWretch';
import useQuery from '@/modules/query-client/hooks/useQuery';
import type { UserProvidedUseQueryOptions } from '@/modules/query-client/types/UserProvidedUseQueryOptions';
import { useTranslation } from 'react-i18next';

export default function useAdminSettingsQuery({
  enabled = false,
  ...options
}: Partial<UserProvidedUseQueryOptions<AdminSettings>> = {}) {
  const wretch = usePublicWretch();
  const { i18n } = useTranslation();

  return useQuery(
    'public',
    createUseAdminSettingsQueryOptions({
      ...options,
      enabled,
      wretch,
      lang: i18n.language,
      useLangInQueryKey: false,
    })
  );
}
